import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Button, Progress } from 'reactstrap'
import { ArrowCircleRight, Medal } from "phosphor-react"
import api from '../../api/api'
import Cookies from 'universal-cookie'
import { processError } from '../../lib/lib'
import thirdCertificate from '../../assets/img/main/1st-place.png'
import secondCertificate from '../../assets/img/main/2nd-place.png'
import firstCertificate from '../../assets/img/main/3rd-place.png'
import forthCertificate from '../../assets/img/main/star-medal.png'
import StudyCardSkeleton from './StudyCardSkeleton'
import ExamCard from './ExamCard'
const cookies = new Cookies()
// eslint-disable-next-line no-undef
const imageUrl = process.env.REACT_APP_IMAGEURL

class CatalogCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            link: `/course/${this.props.id}/mod/1`,
            status: {
                completed: 0,
                from: 0,
                percent: 0,
            },
            fullCourse: {},
            modId: 0,
            medal: '',
            userGrade: {},
        }
        this.routeToCourse = this.routeToCourse.bind(this)
    }

    routeToCourse() {
        // TODO
        if (this.state.status.percent >= 100) {
            this.props.props.history.push(`/course/${this.props.id}/mod/${this.props.themes[0].modules[0].id}`)
        } else {
            this.props.props.history.push(this.state.link)
        }
    }

    getCourseStatus(themes) {
        return new Promise((resolve) => {
            let completed, from, uncompleted, percent
            try {
                completed = ((themes.map((theme) => theme.modules.filter((mod) => mod.complete))).map((arr) => arr.length)).reduce((a, b) => a + b)
            } catch (e) {
                completed = 0
            }
            try {
                from = (themes.map((theme) => theme.modules.length)).reduce((a, b) => a + b)
            } catch (e) {
                from = 0
            }
            try {
                uncompleted = (themes.map((theme) => theme.modules.filter((mod) => !mod.complete))).reduce((a, b) => a.concat(b))
            } catch (e) {
                uncompleted = 0
            }
            percent = completed / from * 100
            resolve({ completed, from, percent, uncompleted })
        })
    }

    getCourseCompleteModule(data) {
        return new Promise((resolve, reject) => {
            api.courseCompleteModule(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.props.history)
                    reject(e)
                })
        })
    }

    async getCourseInfo(themes, token, lang) {
        return new Promise((resolve, reject) => {
            this.getCourseStatus(themes).then(async ({completed, from, uncompleted, percent}) => {
                let modId = 1
                try {
                    const firstMod = (themes.map((theme) => theme.modules.find((mod) => !mod.complete))).find((mod) => mod)
                    if (firstMod.available) modId = firstMod.id
                    else
                        modId = await this.getCourseCompleteModule({ modId: firstMod, token, lang, data: {} })
                } catch (e) {
                    modId = 0
                }
                resolve({ status: { completed, from, percent, uncompleted }, modId })
            }).catch((e) => {
                processError(e, this.props.props.history)
                reject(e)
            })
        })
    }

    async componentWillMount() {
        if (!this.props.skeleton) {
            const token = cookies.get('accessToken')
            const lang = this.props.props.i18n.language
            const { status, modId } = await this.getCourseInfo(this.props.themes, token, lang)
            const link = `/course/${this.props.id}/mod/${modId}`
            this.setState({ status, link, modId })
            switch (this.props.certificate.medalType) {
                case 1:
                    this.setState({ medal: firstCertificate })
                    break
                case 2:
                    this.setState({ medal: secondCertificate })
                    break
                case 3:
                    this.setState({ medal: thirdCertificate })
                    break
                case 4:
                    this.setState({ medal: forthCertificate })
                    break
                default:
                    break
            }
        }
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <StudyCardSkeleton />
                        :
                        <React.Fragment>
                            {
                                this.props.catalogType === 3 ? 
                                    <ExamCard
                                        {...this.state}
                                        {...this.props}
                                    /> :

                                    <div className="col-12">
                                        <div className="col-12 card course-card">
                                            <div className='card-img-wrapper'>
                                                {
                                                    t(`course-type-${this.props.type}`) ? 
                                                        <div className="card-type xs-font-size">{t(`course-type-${this.props.type}`)}</div> : ''
                                                }
                                                <img className="card-img" src={this.props.image ? `${imageUrl}/${this.props.image}` : "data:,"} alt="" onClick={() => {
                                                    if(!this.props.blocked) this.routeToCourse()
                                                }}></img>
                                                {
                                                    this.state.medal ?
                                                        <img
                                                            className="certificate"
                                                            src={this.state.medal}
                                                            alt=""
                                                            width="55"
                                                            height="55"
                                                            onClick={() => this.props.certificate.file ? window.open(`${imageUrl}/certificates/${this.props.certificate.file}`, '_blank') : () => { }}
                                                        /> :
                                                        ''
                                                }
                                            </div>
                                            <div className="card-body-wrapper">
                                                <div className="card-body">
                                                    <div className="card-title lg-font-size">{this.props.title}</div>
                                                    {this.props.programTitle && <div className="md-font-size pt-2">{this.props.programTitle}</div>}
                                                    <div className="card-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                                                    <div className="card-tags xs-font-size">
                                                        {
                                                            this.props.tags.map((tag, index) => (
                                                                <div
                                                                    className={`card-tag xs-font-size ${this.props.activeTags.includes(tag) ? 'active' : ''}`}
                                                                    key={`${tag}-${index}`}
                                                                    id={`${tag}-${index}`}
                                                                    onClick={() => {
                                                                        this.props.toggleBtn(tag)
                                                                        this.props.addToFilters('tags', tag)
                                                                    }}
                                                                >
                                                        #{tag}
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                <div className="card-whitespace"></div>
                                                <div className="card-bottom">
                                                    {
                                                        this.state.status.from ?
                                                            <div className="progress-text">
                                                                <span className="text xs-font-size">{t('study-learn-progress')}</span>
                                                                <span className="number md-font-size">{this.state.status.completed}/{this.state.status.from}</span>
                                                            </div>
                                                            : ''
                                                    }
                                                    {
                                                        this.props.certificate.file ? 
                                                            <Button
                                                                type="button"
                                                                className="btn profile-avatar-btn white p-10-20px noborder"
                                                                onClick={() => window.open(`${imageUrl}/certificates/${this.props.certificate.file}`, '_blank')}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <Medal size={20} />
                                                                    <span className="pl-5px sm-font-size">{t('certificate-see-more')}</span>
                                                                </div>
                                                            </Button> : ''
                                                    }
                                                    <Button
                                                        type="button"
                                                        className="btn profile-avatar-btn grey p-10-20px"
                                                        onClick={this.routeToCourse}
                                                        disabled={this.props.blocked}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <ArrowCircleRight size={20} />
                                                            <span className="pl-5px sm-font-size">
                                                                {
                                                                    this.state.status.completed ?
                                                                        this.state.status.percent >= 100 ?
                                                                            t('study-start-over') :
                                                                            t('study-continue-training')
                                                                        :
                                                                        t('study-start-learning')}
                                                            </span>
                                                        </div>
                                                    </Button>
                                                </div>
                                                {
                                                    this.state.status.from ?
                                                        <Progress
                                                            className={`custom-progress`}
                                                            color={'success'}
                                                            value={this.state.status.percent}
                                                        />
                                                        : ''
                                                }
                                            </div>
                                        </div>
                                    </div>
                            }
                        </React.Fragment>
                }
            </React.Fragment>
        )
    }
}

CatalogCard.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    access: PropTypes.object,
    catalogType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    props: PropTypes.object,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    tags: PropTypes.array,
    partners: PropTypes.array,
    totalPartners: PropTypes.number,
    likes: PropTypes.number,
    themes: PropTypes.array,
    type: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    match: PropTypes.object,
    programTitle: PropTypes.string,
    blocked: PropTypes.bool,
    certificate: PropTypes.object,
    activeTags: PropTypes.array,
    toggleBtn: PropTypes.func,
    addToFilters: PropTypes.func,
    skeleton: PropTypes.bool,
}

export default withTranslation()(CatalogCard)



// WEBPACK FOOTER //
// ./src/components/Study/StudyCard.jsx